import { Currency, CurrencyAmount } from '@kodiak-finance/sdk-core'

export const formatSwapAmount = (amount: CurrencyAmount<Currency> | undefined): string => {
  if (!amount) return ''

  const value = parseFloat(amount.toExact())

  if (isNaN(value) || value <= 0) return '0'

  if (value > 0 && value < 0.000001) {
    return amount.toSignificant(4)
  }

  if (value >= 0.000001 && value < 0.01) {
    return value.toFixed(6)
  }

  // Handle medium amounts (0.01 to 1000) - show 4 decimals
  if (value >= 0.01 && value < 1000) {
    return value.toFixed(3)
  }

  // Handle large amounts (1000+) - show 2 decimals
  if (value >= 1000) {
    return value.toFixed(3)
  }

  // Default fallback
  return amount.toSignificant(6)
}
